const COLORS = {
  GREEN: 'bg-success-200 border border-solid border-success-400',
  YELLOW: 'bg-yellow-200 border border-solid border-yellow-400',
  BLUE: 'bg-primary-200 border border-solid border-primary-400',
  NEUTRAL: 'bg-neutral-75 border border-solid border-neutral-200'
};

export const availableKioskState = {
  inactive: {
    label: 'Inactive',
    color: COLORS.NEUTRAL
  },
  login: {
    label: 'Login screen',
    color: COLORS.BLUE
  },
  'pair-terminal': {
    label: 'Pair terminal',
    color: COLORS.NEUTRAL
  },
  payment: {
    label: 'Payment',
    color: COLORS.GREEN
  },
  'url-change': {
    label: 'URL change',
    color: COLORS.NEUTRAL
  },
  idle: {
    label: 'Idle',
    color: COLORS.YELLOW
  },
  'payment-init': {
    label: 'Taking a new payment',
    color: COLORS.GREEN
  },
  'payment-cancel': {
    label: 'Payment canceled',
    color: COLORS.YELLOW
  },
  unpaired: {
    label: 'Unpaired',
    color: COLORS.NEUTRAL
  }
};
